import { Button, Stack, Typography, useTheme } from "@mui/material";
import type { FC, ReactNode } from "react";
import { MyPlannDrawer } from "web_myplann/Shared/Components/MyPlannDrawer";

type Props = {
	open: boolean;
	onClose: () => void;
	title: string;
	description: string;
	primaryLabel: string;
	onPrimary: () => void;
	secondaryLabel?: string;
	onSecondary?: () => void;
	children: ReactNode;
};

export const InspirationSheet: FC<Props> = ({
	open,
	onClose,
	title,
	description,
	primaryLabel,
	onPrimary,
	secondaryLabel,
	onSecondary,
	children,
}) => {
	const theme = useTheme();

	return (
		<MyPlannDrawer
			open={open}
			onClose={onClose}
			closeButton
			title={title}
			paperSx={{ bgcolor: theme.palette.background.paper }}
		>
			<Stack px={1.6} pt={0.4} pb={4} gap={1.2}>
				<Typography variant="body1" color={theme.palette.grey[500]}>
					{description}
				</Typography>

				{children}

				<Button variant="primary" onClick={onPrimary}>
					{primaryLabel}
				</Button>

				{secondaryLabel && onSecondary && (
					<Button variant="tertiary" onClick={onSecondary}>
						{secondaryLabel}
					</Button>
				)}
			</Stack>
		</MyPlannDrawer>
	);
};
